export const formatNumber = (value: number | string): string => {
  return Number(value).toLocaleString('de-DE'); // 'de-DE' uses dot as thousands separator
};
